import { RadarRing } from "@backstage/plugin-tech-radar";

export const ringsENUM = {
  ADOPT: 'Adopt',
  TRIAL: 'Trial',
  ASSESS: 'Assess',
  HOLD: 'Hold',
}

const rings: RadarRing[] = [
  { id: 'Adopt', name: 'ADOPT', color: '#93c47d' },
  { id: 'Trial', name: 'TRIAL', color: '#93d2c2' },
  { id: 'Assess', name: 'ASSESS', color: '#fbdb84' },
  { id: 'Hold', name: 'HOLD', color: '#efafa9' },
];

export default rings;
